import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEventCallback } from 'usehooks-ts';

import { getValorantPlayerOptions } from '@/features/games/valorant/hooks/useGetValorantPlayer';
import {
  Profile,
  ProfileNotFound,
  ProfileSkeleton,
} from '@/features/profile/components/profile';
import { getProfileOptions } from '@/features/profile/hooks/useGetProfile';
import { MainLayout } from '@/shared/components/mainLayout';
import { PageHeader } from '@/shared/components/pageHeader';

export const Route = createFileRoute(
  '/_protected/_app/_mainLayout/profiles/$profileId',
)({
  loader: async ({ context, params }) => {
    const profileData = await context.queryClient.ensureQueryData(
      getProfileOptions({ userId: params.profileId }),
    );

    // Prefetch valorant data if riotPuuid is available
    if (profileData.profile?.riotPuuid) {
      await context.queryClient.ensureQueryData(
        getValorantPlayerOptions({ puuid: profileData.profile.riotPuuid }),
      );
    }
  },
  errorComponent: () => (
    <MainLayout.Root className="h-full">
      <PageHeader.Root>
        <PageHeader.BackButton
          onClick={() => {
            window.history.back();
          }}
        />
      </PageHeader.Root>
      <MainLayout.Content className="mx-auto flex min-h-0 w-full flex-col overflow-hidden px-4 lg:max-w-100">
        <ProfileNotFound className="mb-2 max-h-165 min-h-0 w-full max-w-100 flex-1" />
      </MainLayout.Content>
    </MainLayout.Root>
  ),
  pendingComponent: () => (
    <MainLayout.Root className="h-full">
      <PageHeader.Root>
        <PageHeader.BackButton
          onClick={() => {
            window.history.back();
          }}
        />
      </PageHeader.Root>
      <MainLayout.Content className="mx-auto flex min-h-0 w-full flex-col overflow-hidden px-4 lg:max-w-100">
        <ProfileSkeleton className="mb-2 max-h-165 min-h-0 w-full max-w-100 flex-1" />
      </MainLayout.Content>
    </MainLayout.Root>
  ),
  component: RouteComponent,
});

function RouteComponent() {
  const { profileId } = Route.useParams();
  const navigate = useNavigate();

  const handleGoBack = useEventCallback(() => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      void navigate({ to: '/' });
    }
  });

  return (
    <MainLayout.Root className="h-full">
      <PageHeader.Root>
        <PageHeader.BackButton onClick={handleGoBack} />
      </PageHeader.Root>
      <MainLayout.Content className="flex min-h-0 w-full flex-col items-center px-4">
        <Profile
          className="mb-4 max-h-full min-h-0 w-full max-w-100"
          profileId={profileId}
        />
      </MainLayout.Content>
    </MainLayout.Root>
  );
}
